import styled from 'styled-components'
import Icon from '@chegg-wt/core/components/Icon'
import { Heading2, BodyMedium } from '@chegg-wt/core/theme/sunkist/typography'
import { AspiraBold } from '@chegg-wt/core/theme/sunkist/fonts'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { font } from '@chegg-ui/theme'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Border = styled.div`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor10};
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor05};
  border-radius: 6px;
  margin-bottom: ${values.small};
  padding: ${values.xsmall};
  position: relative;
`

export const CloseButton = styled(Icon)`
  position: absolute;
  cursor: pointer;
  top: 3px;
  right: -3px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    flex-direction: row;
  }
`

export const Content = styled.div`
  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    margin-left: ${values.xsmall};
  }
`

export const Header = styled.h2`
  ${Heading2};
  margin-bottom: ${values.base};
  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    margin: 0;
    margin-bottom: ${values.base};
  }
`

export const Bold = styled.strong`
  ${AspiraBold};
`

export const P = styled.p<{ marginBottom?: string }>`
  ${BodyMedium};
  margin-top: 2px;
  margin-bottom: ${({ marginBottom = '2px' }) => marginBottom};
`

export const LinkToPapers = styled.div`
  > a {
    font-size: ${font.size.px14};
  }
  display: block;
  margin-top: ${values.xxsmall};
  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    display: inline;
    margin-left: ${values.xsmall};
  }
`
